let xzqh = { code: "371524", name: "东阿县" }; // object with code and name
let apps = []; // with title and url

if (process.env.VUE_APP_XZQH) {
  xzqh = JSON.parse(process.env.VUE_APP_XZQH);
}
if (process.env.VUE_APP_APPS) {
  apps = JSON.parse(process.env.VUE_APP_APPS);
}
const system = {
  state: {
    apps,
    xzqh,
  },
  actions: {},
};
export default system;
